import React from 'react';
import { reduxForm, Field, getFormValues, isDirty } from 'redux-form';
import { connect } from 'react-redux';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import DropdownCalendarOld from 'components/Fields/ReduxForm/DropdownCalendarOld';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import { ActionBarWrapper } from 'components/wrappers/pages';
import { Modal, MenuItem } from 'react-bootstrap';
import DropdownButtonSelectIcon from 'components/Fields/ReduxForm/DropdownButtonSelectIcon';
import {
  onChangeOutletIds,
  onChangeDate,
  onChangeNamespace,
  onChangeKeyword,
  onChangeStatus,
  exportPurchaseOrder,
  onClickCreatePO,
  onSuccessImport,
  showImportModal,
  hideImportModal,
} from 'actions/inventory/purchaseOrder';
import moment from 'moment';
import * as actNotif from 'actions/notifications';
import { askConfirmAction } from 'actions/confirm-action';
import Dropdown from 'components/Dropdown';
import ImportModal from 'components/ImportModal';
import * as clevertapInventoryPurchaseOrders from 'clevertap/inventory/purchaseOrders';
import MenuTitle from 'components/MenuTitle';
import { isFullSiteMode } from 'utils/fullSite';
import {
  V1_EXPORT_TEMPLATE_PURCHASE_ORDER as V1_EXPORT_TEMPLATE_PURCHASE_ORDER_ITEM,
  V1_IMPORT_PURCHASE_ORDER as V1_IMPORT_PURCHASE_ORDER_ITEM,
  V1_IMPORT_TEMPORARY_PURCHASE_ORDER as V1_IMPORT_TEMPORARY_PURCHASE_ORDER_ITEM,
} from 'api/inventory/purchaseOrder/constants';
import {
  V1_EXPORT_TEMPLATE_PURCHASE_ORDER as V1_EXPORT_TEMPLATE_PURCHASE_ORDER_INGREDIENT,
  V1_IMPORT_PURCHASE_ORDER as V1_IMPORT_PURCHASE_ORDER_INGREDIENT,
  V1_IMPORT_TEMPORARY_PURCHASE_ORDER as V1_IMPORT_TEMPORARY_PURCHASE_ORDER_INGREDIENT,
} from 'api/ingredientInventory/purchaseOrder/constant';
import * as clevertapInventorySuppliers from 'clevertap/inventory/suppliers';
import { exportSupplier } from 'actions/inventory/supplier';
import InformationModal from 'components/ImportModal/InformationModal';
import {
  ITEMS_PURCHASE_ORDER,
  INGREDIENTS_PURCHASE_ORDER,
} from 'utils/uploadS3Constants';
import styles from './ActionBar.css';

class ActionBar extends React.Component {
  static NAMESPACE_OPTIONS = [
    {
      id: 'items',
      name: 'Item Library',
    },
    {
      id: 'ingredients',
      name: 'Ingredients',
    },
  ];

  static STATUS_OPTIONS = [
    {
      id: '',
      name: 'All Status',
    },
    {
      id: 'Updated',
      name: 'Updated',
      icon: 'glyphicon glyphicon-plus btn btn-warning',
    },
    {
      id: 'Created',
      name: 'Created',
      icon: 'glyphicon glyphicon-plus btn btn-warning ',
    },
    {
      id: 'Fulfilled',
      name: 'Fulfilled',
      icon: 'glyphicon glyphicon-ok btn btn-success fulfilled',
    },
    {
      id: 'Cancelled',
      name: 'Cancelled',
      icon: 'glyphicon glyphicon-minus btn btn-danger',
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      supplierError: false,
      importError: false,
      noDataToImportError: false,
      informationModalText: '',
    };
  }

  render() {
    const {
      outlets,
      isDirtyForm,
      isIngredientActive,
      search,
      business,
    } = this.props;
    return (
      <div>
        <MenuTitle menuTitle="Purchase Order (PO)" />
        <div
          className="col-sm-2 hidden-xs col-md-6 action-purchase-order"
          style={{ paddingRight: 0 }}
        >
          <span className="pull-right">
            {!isFullSiteMode() && (
              <Dropdown>
                <Dropdown.Toggle
                  title="Import / Export"
                  bsStyle="primary"
                ></Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem onSelect={this._onClickImport}>Import PO</MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={this._onClickExport}>Export PO</MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            )}
            <button
              className="btn btn-primary ml-10px"
              onClick={this._onClickCreatePurchaseOrder}
            >
              Create PO
            </button>
          </span>
        </div>
        <ActionBarWrapper>
          <div className="col-sm-12 col-xs-12" style={{ paddingLeft: 0 }}>
            <form className={`form-inline ${styles['action-bar']}`}>
              <div className="form-group mr-5px">
                <Field
                  name="outletIds"
                  component={DropdownOutlet}
                  outlets={outlets}
                  allOutletOption
                  onChangeOutletIds={this._onChangeOutletIds}
                />
              </div>
              <div className="form-group mr-5px">
                <Field
                  component={DropdownCalendarOld}
                  name="date"
                  onChange={this._onChangeDate}
                  isDirtyForm={isDirtyForm}
                  onDirtyFormCallback={this._onChangeDate}
                />
              </div>
              <div className="form-group mr-5px">
                <Field
                  component={DropdownButtonSelectIcon}
                  name="namespace"
                  options={ActionBar.NAMESPACE_OPTIONS}
                  onChange={this._onChangeNamespace}
                  isDirtyForm={isDirtyForm}
                  onDirtyFormCallback={this._onChangeNamespace}
                  disabled={!isIngredientActive}
                />
              </div>
              <div className="form-group mr-5px">
                <Field
                  component={DropdownButtonSelectIcon}
                  name="status"
                  options={ActionBar.STATUS_OPTIONS}
                  onChange={this._onChangeStatus}
                />
              </div>
              <div className="form-group mr-5px">
                <Field
                  component={SearchBar}
                  name="keyword"
                  onChange={this._onChangeKeyword}
                  placeholder="Search"
                />
              </div>
            </form>
          </div>
          {this._namespace() === 'items' && (
            <ImportModal
              dispatch={this.props.dispatch}
              pathImporting="outlet"
              templateImportUrl={V1_EXPORT_TEMPLATE_PURCHASE_ORDER_ITEM}
              temporaryImportUrl={V1_IMPORT_TEMPORARY_PURCHASE_ORDER_ITEM}
              importUrl={V1_IMPORT_PURCHASE_ORDER_ITEM}
              namespace="purchase order (PO)"
              business={business}
              outlets={outlets}
              selectedOutletIds={search ? search.outletIds : []}
              onCancel={this._onCancelImportErrorModal}
              show={this.props.showImportModal}
              afterSuccessCallback={this._importAfterSuccessCallback}
              onErrorCallback={this._importOnErrorCallback}
              templatePrefix="Import - Items Purchase Order - "
              filterNamespace="items"
              footer={this._footer()}
              header={this._header()}
              csvHeaders={[
                'Internal ID (Do Not Edit)',
                'Outlet Name (Do Not Edit)',
                'Supplier Email',
                'Items Name (Do Not Edit)',
                'Variant Name (Do Not Edit)',
                'Category (Do Not Edit)',
                'SKU (Do Not Edit)',
                'In Stock (Do Not Edit)',
                'Order',
                'Unit Cost',
              ]}
              usingSpringImport="true"
              importNamespace={ITEMS_PURCHASE_ORDER}
            />
          )}
          {this._namespace() === 'ingredients' && (
            <ImportModal
              dispatch={this.props.dispatch}
              pathImporting="outlet"
              templateImportUrl={V1_EXPORT_TEMPLATE_PURCHASE_ORDER_INGREDIENT}
              temporaryImportUrl={V1_IMPORT_TEMPORARY_PURCHASE_ORDER_INGREDIENT}
              importUrl={V1_IMPORT_PURCHASE_ORDER_INGREDIENT}
              namespace="purchase order (PO)"
              business={business}
              outlets={outlets}
              selectedOutletIds={search ? search.outletIds : []}
              onCancel={this._onCancelImportErrorModal}
              show={this.props.showImportModal}
              afterSuccessCallback={this._importAfterSuccessCallback}
              onErrorCallback={this._importOnErrorCallback}
              templatePrefix="Import - Ingredient Purchase Order - "
              filterNamespace="items"
              footer={this._footer()}
              header={this._header()}
              csvHeaders={[
                'Internal ID (Do Not Edit)',
                'Outlet Name (Do Not Edit)',
                'Supplier Email',
                'Ingredient Name (Do Not Edit)',
                'Category (Do Not Edit)',
                'Unit (Do Not Edit)',
                'In Stock (Do Not Edit)',
                'Order',
                'Unit Cost',
              ]}
              usingSpringImport="true"
              importNamespace={INGREDIENTS_PURCHASE_ORDER}
            />
          )}
          <InformationModal
            show={this.state.noDataToImportError}
            onHide={this._onHideInformationModal}
            message={this.state.informationModalText}
          />
        </ActionBarWrapper>
      </div>
    );
  }

  _onHideInformationModal = () => {
    this.setState({ noDataToImportError: false });
  };

  _importAfterSuccessCallback = () => {
    this.props.dispatch(onSuccessImport());
    const {
      search: { outletIds },
    } = this.props;
    clevertapInventoryPurchaseOrders.inventoryPOImportSuccess({
      outletIds,
    });
  };

  _onCancelImportErrorModal = () => this.props.dispatch(hideImportModal());

  _importOnErrorCallback = (errors, errorCode) => {
    const {
      search: { outletIds },
    } = this.props;
    if (parseInt(errorCode / 100) === 5) {
      this.props.dispatch(hideImportModal());
      if (errors[0].indexOf('Invalid') > -1) {
        this.setState({
          noDataToImportError: true,
          informationModalText: errors[0],
        });
      }
    }
    this.setState({
      importError: true,
      supplierError: this._hasSupplierError(errors),
    });

    this.props.dispatch(actNotif.error(errors[0]));
    clevertapInventoryPurchaseOrders.inventoryPOImportFailed({
      outletIds,
    });
  };

  _hasSupplierError = errors => {
    return (
      errors.filter(function(error) {
        return error.indexOf('not registered') > -1;
      }).length > 0
    );
  };

  _onClickImport = () => {
    this.setState({
      supplierError: false,
      importError: false,
    });
    this.props.dispatch(showImportModal());
  };

  _onClickExport = () => {
    const {
      dispatch,
      search: {
        status,
        keyword,
        date: { startDate, endDate },
        namespace,
        outletIds,
      },
    } = this.props;
    const dateLabel = startDate.isSame(endDate, 'days')
      ? moment(startDate).format('DD-MM-YYYY')
      : [
          moment(startDate).format('DD-MM-YYYY'),
          moment(endDate).format('DD-MM-YYYY'),
        ].join(' - ');
    let filename = '';
    if (namespace === 'items') {
      filename = `Export - Items Purchase Order - ${dateLabel}`;
    } else {
      filename = `Export - Ingredient Purchase Order - ${dateLabel}`;
    }
    clevertapInventoryPurchaseOrders.inventoryPOExport({
      outletIds,
      startDate,
      endDate,
      namespace,
    });
    dispatch(
      exportPurchaseOrder(
        {
          start: moment(startDate).format('D/M/YYYY'),
          end: moment(endDate).format('D/M/YYYY'),
          status,
          keyword,
          namespace,
        },
        filename,
        outletIds[0]
      )
    );
  };

  _onClickCreatePurchaseOrder = () => {
    const {
      dispatch,
      search: { outletIds },
      isDirtyForm,
    } = this.props;
    if (isDirtyForm) {
      dispatch(askConfirmAction(onClickCreatePO(outletIds)));
    } else {
      dispatch(onClickCreatePO(outletIds));
    }
  };

  /**
   * Redux form auto convert array to objects, so we change it back to array
   * @private
   * @param outletIdsAsObject
   */
  _onChangeOutletIds = outletIds => {
    const {
      dispatch,
      search: {
        date: { startDate, endDate },
        status,
        namespace,
        keyword,
      },
      isDirtyForm,
    } = this.props;

    if (isDirtyForm) {
      dispatch(
        askConfirmAction(
          onChangeOutletIds(outletIds, namespace, {
            page: 1,
            start: startDate.format('D/M/Y'),
            end: endDate.format('D/M/Y'),
            status,
            keyword,
          })
        )
      );
    } else {
      dispatch(
        onChangeOutletIds(outletIds, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status,
          keyword,
        })
      );
    }
  };

  _onChangeStatus = (event, status) => {
    const {
      dispatch,
      search: {
        date: { startDate, endDate },
        namespace,
        keyword,
      },
      isDirtyForm,
    } = this.props;
    if (isDirtyForm) {
      dispatch(
        askConfirmAction(
          onChangeStatus(status, namespace, {
            page: 1,
            start: startDate.format('D/M/Y'),
            end: endDate.format('D/M/Y'),
            status,
            keyword,
          })
        )
      );
    } else {
      dispatch(
        onChangeStatus(status, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status,
          keyword,
        })
      );
    }
  };

  _onChangeDate = ({ startDate, endDate }) => {
    const {
      dispatch,
      search: { status, namespace, keyword },
      isDirtyForm,
    } = this.props;
    if (isDirtyForm) {
      dispatch(
        askConfirmAction(
          onChangeDate(startDate, endDate, namespace, {
            page: 1,
            start: startDate.format('D/M/Y'),
            end: endDate.format('D/M/Y'),
            status,
            keyword,
          })
        )
      );
    } else {
      dispatch(
        onChangeDate(startDate, endDate, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status,
          keyword,
        })
      );
    }
  };

  _onChangeNamespace = (event, namespace) => {
    // previousNamespace is reserved for clevertap tracking
    const {
      dispatch,
      search: {
        status,
        date: { startDate, endDate },
        keyword,
      },
      isDirtyForm,
    } = this.props;
    if (isDirtyForm) {
      dispatch(
        askConfirmAction(
          onChangeNamespace(namespace, {
            page: 1,
            start: startDate.format('D/M/Y'),
            end: endDate.format('D/M/Y'),
            status,
            keyword,
          })
        )
      );
    } else {
      dispatch(
        onChangeNamespace(namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status,
          keyword,
        })
      );
    }
  };

  _onChangeKeyword = (event, keyword) => {
    const {
      dispatch,
      search: {
        status,
        namespace,
        date: { startDate, endDate },
      },
      isDirtyForm,
    } = this.props;
    if (isDirtyForm) {
      dispatch(
        askConfirmAction(
          onChangeKeyword(keyword, namespace, {
            page: 1,
            start: startDate.format('D/M/Y'),
            end: endDate.format('D/M/Y'),
            status,
            keyword,
          })
        )
      );
    } else {
      dispatch(
        onChangeKeyword(keyword, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status,
          keyword,
        })
      );
    }
  };

  _namespace = () => {
    const { search } = this.props;
    if (search) {
      return search.namespace;
    }
    return '';
  };

  _onClickDownloadSupplier = () => {
    const { dispatch, email } = this.props;
    clevertapInventorySuppliers.inventorySupplierExport();
    const filename = `Inventory Suppliers - ${email}`;

    dispatch(exportSupplier({ email }, filename));
  };

  _header = () => {
    if (this.state.importError) {
      return <Modal.Title> Import PO Error </Modal.Title>;
    }
    return <Modal.Title> Import PO </Modal.Title>;
  };

  _footer = () => {
    return (
      this.state.importError && (
        <div>
          {this.state.supplierError && (
            <span className="pull-left" style={{ marginRight: '30%' }}>
              * Download list of supplier{' '}
              <a href="#" onClick={this._onClickDownloadSupplier}>
                here
              </a>
            </span>
          )}
          <span className="pull-left">
            <a
              className="btn btn-default"
              onClick={this._onCancelImportErrorModal}
            >
              Cancel
            </a>
          </span>
          <span className="pull-right">
            <a className="btn btn-primary" onClick={this._reUploadButton}>
              Re-Upload
            </a>
          </span>
        </div>
      )
    );
  };

  _reUploadButton = () => {
    reUpload(this);
  };
}

const mapForm = {
  form: 'search',
};

async function reUpload(modal) {
  await modal.props.dispatch(hideImportModal());
  await modal._onClickImport();
}

function mapStateToProps(state) {
  const {
    outlets,
    showImportModal,
    isExportLoading,
  } = state.inventory.purchaseOrder;
  const { email } = state.moka.user;
  const { business } = state.moka.user;
  const {
    subscriptionStatus: { is_active },
  } = state.inventory.ingredientSubscription;
  return {
    outlets,
    search: getFormValues('search')(state),
    showImportModal,
    isDirtyForm: isDirty('purchaseOrder')(state),
    isIngredientActive: is_active,
    email,
    business,
    isExportLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(ActionBar));
